
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    options: {
      type: Array
    }
  },
  data () : { canScrollUp: boolean, canScrollDown: boolean } {
    return {
      canScrollUp: false,
      canScrollDown: false
    }
  },
  watch: {
    options () {
      this.handleScroll()
    }
  },
  methods: {
    handleScroll (): void {
      this.$nextTick(() => {
        const scrollContainer = this.$refs.scrollContainer as HTMLElement
        if (!scrollContainer) return
        this.canScrollUp = scrollContainer.scrollTop > 0
        this.canScrollDown = scrollContainer.scrollTop + scrollContainer.clientHeight < scrollContainer.scrollHeight
      })
    },
    scrollUp (): void {
      const scrollContainer = this.$refs.scrollContainer as HTMLElement
      if (!scrollContainer) return
      scrollContainer.scrollBy({
        top: -200,
        behavior: 'smooth'
      })
    },
    scrollDown () : void {
      const scrollContainer = this.$refs.scrollContainer as HTMLElement
      if (!scrollContainer) return
      scrollContainer.scrollBy({
        top: 200,
        behavior: 'smooth'
      })
    }
  },
  mounted () : void {
    this.handleScroll()
  }
})
